import './ImageIcon.css'
import React from 'react' 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default props => (
    <div className="contact-icon">
        <FontAwesomeIcon icon={[props.iconGroup, props.iconName]} />
    </div>
)
